import { API_STATUS } from 'constants/constants';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from 'store/reducers/list';

const usePage = ({ name, pageSize, defaultParams = {} }) => {
  const {
    data = [],
    status,
    meta,
  } = useSelector((state) => state.list[name]) || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState(defaultParams);
  const dispatch = useDispatch();

  const onChangeField = (v, field) => {
    setSearch(search => ({ ...search, [field]: v }));
  };

  const onChangeFieldText = (e, field) => {
    onChangeField(e.target.value, field);
  };

  const onChangePage = (v) => {
    setCurrentPage(v);
  };

  // eslint-disable-next-line
  const fetch = useCallback(
    debounce(
      (params, currentPage) =>
        dispatch(
          fetchData({
            params: {
              ...params,
              skip: (currentPage - 1) * pageSize,
              limit: pageSize,
            },
            name,
          })
        ),
      200
    ),
    []
  );

  useEffect(() => {
    if (status !== API_STATUS.PROCESSING) {
      fetch(search, currentPage);
    } // eslint-disable-next-line
  }, [currentPage, search]);

  return {
    data,
    status,
    meta,
    search,
    onChangeField,
    onChangeFieldText,
    onChangePage,
    currentPage
  };
};

export default usePage;
